// extracted by mini-css-extract-plugin
export var background = "index-module--background--SGgoc";
export var iframe = "index-module--iframe--+NypL";
export var intrinsic = "index-module--intrinsic---nTJV";